import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { JsonSchemaFormService } from 'angular6-json-schema-form';
import { set } from 'lodash-es';

@Component({
  selector: 'app-widget-conditional',
  templateUrl: './widget-conditional.component.html',
  styleUrls: ['./widget-conditional.component.scss'],
})
export class WidgetConditionalComponent implements OnInit {
  @Input() options: any;
  @Input() layoutNode: any;
  @Input() controlValue: any;
  @Output() updateValue: EventEmitter<any> = new EventEmitter<any>();
  @Input() template: TemplateRef<any>;
  public conditionalValue: {
    title: string;
    defaultValue: string;
    dependentValuesReset?: { [valuePath: string]: any };
  };
  public isConditional: boolean = false;
  public displayed: boolean = true;
  default: Function;
  type: string;
  title: string;

  constructor(private jsonSchemaFormService: JsonSchemaFormService) {}

  ngOnInit() {
    const layout = this.jsonSchemaFormService.layout.find(
      (l) => l._id === this.layoutNode._id
    );
    this.type = layout ? layout.type : 'text';
    if (this.type.startsWith('conditional-')) {
      this.title = layout
        ? layout.options.notitle
          ? ''
          : layout.options.title
        : '';
      if (this.options.conditionalValue) {
        this.conditionalValue = this.options.conditionalValue;
        this.displayed = !!this.controlValue;

        if (this.conditionalValue.defaultValue) {
          this.default = new Function(
            'model',
            this.conditionalValue.defaultValue
          );
        }
        this.isConditional = true;
      }
    }
  }

  public onDisplayChange(displayed: boolean): void {
    if (displayed) {
      const value: string = this.default
        ? this.default(this.jsonSchemaFormService.data)
        : 'Enter value';
      this.updateValue.next({ target: { value: value } });
    } else {
      this.updateValue.next({ target: { value: '' } });
      if (this.conditionalValue.dependentValuesReset) {
        for (const valuePath of Object.keys(
          this.conditionalValue.dependentValuesReset
        )) {
          this.jsonSchemaFormService.data.locationPosition = '';
          set(
            this.jsonSchemaFormService.data,
            valuePath,
            this.conditionalValue.dependentValuesReset[valuePath]
          );
        }
      }
    }
  }
}
